const data = {
  id: 1,
  title: ' Choose the correct ordinal numbers.',
  subTitle: '(Chọn số thứ tự tương ứng)',
  question: 'Three => ?',
  answers: [
    { id: 1, answer: 'third', isCorrect: true },
    { id: 2, answer: 'first', isCorrect: false },
    { id: 3, answer: 'second', isCorrect: false },
  ],
};

export default data;
